import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./global.css";
import { initWebVitals } from "./utils/webVitals";

// Initialize Web Vitals tracking
if (typeof window !== 'undefined') {
  initWebVitals();
}

createRoot(document.getElementById("root")!).render(<App />);
